<template>
    <div class='page'>
        <!-- 搜索 -->
        <el-form v-if='isSearch' :model='queryForm' ref='form' label-width='80px' :inline='true' size='small'
                 class='query-form' @submit.native.prevent>
<!--            <el-form-item label='数值类型'>-->
<!--                <el-select-->
<!--                    v-model="queryForm.valueType"-->
<!--                    placeholder="请选择数值类型"-->
<!--                    clearable-->
<!--                    size="small"-->
<!--                    style="width: 200px"-->
<!--                >-->
<!--                    <el-option v-for="item in globalvalueTypeEnumList" :key="item.key" :label="item.value" :value="item.key"> </el-option>-->
<!--                </el-select>-->
<!--            </el-form-item>-->
            <el-form-item label='用户'>
                <GridSelect
                    style='width: 200px'
                    title='选择用户'
                    labelName='userName'
                    labelValue='id'
                    :value='queryForm.userId'
                    :limit='1'
                    size='small'
                    placeholder='请选择用户'
                    @getValue='getValue'
                    :columns="USER_code"
                    :searchs="USER_search"
                    dataListUrl='/mpp/user/findList'
                    entityBeanName='mppUser'
                    queryEntityUrl='/mpp/user/get'
                >
                </GridSelect>
            </el-form-item>
            <el-form-item>
                <el-button size='small' type='primary' icon='el-icon-search' @click='getMppGlobalvalueRecordList'>查询
                </el-button>
                <el-button size='small' icon='el-icon-refresh' @click='resetDialog'>重置</el-button>
            </el-form-item>
        </el-form>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
<!--                    <el-button-->
<!--                        type='primary'-->
<!--                        size='small'-->
<!--                        icon='el-icon-plus'-->
<!--                        @click='addMppGlobalvalueRecord'-->
<!--                    >新建-->
<!--                    </el-button>-->
<!--                    <el-button-->
<!--                        type='warning'-->
<!--                        plain-->
<!--                        size='small'-->
<!--                        icon='el-icon-edit'-->
<!--                        :disabled='multipleSelection.length != 1'-->
<!--                        @click='editMppGlobalvalueRecord(null)'-->
<!--                    >修改-->
<!--                    </el-button>-->
                    <el-button
                        type='danger'
                        plain
                        size='small'
                        icon='el-icon-delete'
                        :disabled='multipleSelection.length <= 0'
                        @click='deleteMppGlobalvalueRecord(null)'
                    >删除
                    </el-button>
                </div>

                <div class='icon-group'>
                    <el-upload v-if='this.isImportDate'
                               class='upload-demo'
                               action='#'
                               :http-request='upload'
                               :show-file-list='true'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title='搜索'
                        class='icon-box'
                        @click='search'
                    >
                      <Icon color='#606266'>
                        <Search />
                      </Icon>
                    </span>
                    <!--        <span-->
                    <!--          title="下载模板"-->
                    <!--          class="icon-box"-->
                    <!--          @click="importTemplate"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDown />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          class="icon-box"-->
                    <!--          title="导入数据"-->
                    <!--          @click="isImport"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowExportUp24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          title="导出数据"-->
                    <!--          class="icon-box"-->
                    <!--          @click="exportMppGlobalvalueRecordList"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDownload24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <span
                        class='icon-box'
                        @click='refreshMppGlobalvalueRecordList'
                    >
                      <Icon color='#606266'>
                        <Refresh />
                      </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data='mppGlobalvalueRecordList'
                row-key='id'
                border
                height='100%'
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change='handleSelectionChange'
                size='small'
            >
                <el-table-column
                    align='center'
                    type='selection'
                    width='60'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='valueType'
                    label='数值类型'
                    width='180'
                >
                    <template slot-scope='scop'>
                        <div>{{ computeGlobalvalueType(scop.row.valueType) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='value'
                    label='数值'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='orientation'
                    label='方向'
                    width='180'
                >
                    <template slot-scope='scop'>
                        <div>{{computeGlobalvalueOrientation(scop.row.orientation)}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='originalValue'
                    label='原来值'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='restValue'
                    label='剩余值'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='userId'
                    label='用户'
                    width='180'
                >
                    <template slot-scope="scope">
                        <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                        <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                        <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                        <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='createTime'
                    label='创建时间'
                    width='180'
                ></el-table-column>
                <el-table-column
                    fixed='right'
                    align='center'
                    label='操作'
                    width='300'
                >
                    <template slot-scope='scop'>
                        <div class='operation'>
                            <div @click='checkMppGlobalvalueRecord(scop.row.id)'>
                                <Icon size='16'>
                                    <Eye24Regular />
                                </Icon>
                                <span class='operation-label'>查看</span>
                            </div>
<!--                            <div @click='editMppGlobalvalueRecord(scop.row.id)'>-->
<!--                                <Icon size='16'>-->
<!--                                    <Edit24Regular />-->
<!--                                </Icon>-->
<!--                                <span class='operation-label'>修改</span>-->
<!--                            </div>-->
                            <div @click='deleteMppGlobalvalueRecord(scop.row.id)'>
                                <Icon size='16' style='color: red'>
                                    <Delete24Regular />
                                </Icon>
                                <span class='operation-label' style='color: red'>删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='sizeChange'
                    @current-change='currentChange'
                    :current-page.sync='currentPage'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    :total='totalNum'
                    background
                    :pager-count='7'
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title='mppGlobalvalueRecordStates[mppGlobalvalueRecordState]'
                :visible.sync='showDialog'
                width='60%'
                @close='closeDialog'
                :modal="false"
            >
                <div>
                    <el-form
                        :model='mppGlobalvalueRecord'
                        ref='mppGlobalvalueRecordForm'
                        :rules='rules'
                        label-width='120px'
                        :inline='true'
                        size='small'
                    >
                        <el-form-item
                            label='数值类型'
                            prop='valueType'
                        >
                            <el-input
                                size='small'
                                v-model='mppGlobalvalueRecord.valueType'
                                :disabled="mppGlobalvalueRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='数值'
                            prop='value'
                        >
                            <el-input
                                size='small'
                                v-model='mppGlobalvalueRecord.value'
                                :disabled="mppGlobalvalueRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='方向'
                            prop='orientation'
                        >
                            <el-input
                                size='small'
                                v-model='mppGlobalvalueRecord.orientation'
                                :disabled="mppGlobalvalueRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='原来值'
                            prop='originalValue'
                        >
                            <el-input
                                size='small'
                                v-model='mppGlobalvalueRecord.originalValue'
                                :disabled="mppGlobalvalueRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='剩余值'
                            prop='restValue'
                        >
                            <el-input
                                size='small'
                                v-model='mppGlobalvalueRecord.restValue'
                                :disabled="mppGlobalvalueRecordState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='用户ID'
                            prop='userId'
                        >
                            <GridSelect
                                style='width: 180px'
                                title='选择用户'
                                labelName='userName'
                                labelValue='id'
                                :value='mppGlobalvalueRecord.userId'
                                :limit='1'
                                size='small'
                                placeholder='请选择用户'
                                :disabled="mppGlobalvalueRecordState == 'check'"
                                @getValue='getValueForm'
                                :columns="USER_code"
                                :searchs="USER_search"
                                dataListUrl='/mpp/user/findList'
                                entityBeanName='mppUser'
                                queryEntityUrl='/mpp/user/get'
                            >
                            </GridSelect>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot='footer'
                    class='flex justify-end'
                >
                    <el-button @click='closeDialog'>关闭</el-button>
                    <el-button
                        type='primary'
                        @click='submitForm'
                        v-if="mppGlobalvalueRecordState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelect from '@/components/gridselect';
import { USER, USER_SEARCH } from '@/utils/constant';
export default {
    components: {
        GridSelect,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMppGlobalvalueRecordList();
                this.getMppGlobalvalueRecordList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMppGlobalvalueRecordList();
                this.getMppGlobalvalueRecordList();
                this.$emit('resetCheckState');
            }
        }
    },
    props:{
      valueType:{
          type:Number,
          default:0
      }
    },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            globalvalueOrientationEnumList: [],
            globalvalueTypeEnumList: [],

            queryForm: {
                valueType: '', //数值类型
                value: '', //数值
                orientation: '', //方向
                originalValue: '', //原来值
                restValue: '', //剩余值
                userId: '' //用户ID
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            mppGlobalvalueRecordState: 'add',
            mppGlobalvalueRecordStates: {
                add: '新建全局数据记录',
                check: '查看全局数据记录',
                edit: '修改全局数据记录'
            },

            multipleSelection: [],
            mppGlobalvalueRecordList: [],
            mppGlobalvalueRecord: {
                valueType: '', //数值类型
                value: '', //数值
                orientation: '', //方向
                originalValue: '', //原来值
                restValue: '', //剩余值
                userId: '' //用户ID
            },
            btnLoading: false,

            rules: {
                valueType: [{ required: true, message: '数值类型不能为空', trigger: 'blur' }],
                value: [{ required: true, message: '数值不能为空', trigger: 'blur' }],
                orientation: [{ required: true, message: '方向不能为空', trigger: 'blur' }],
                originalValue: [{ required: true, message: '原来值不能为空', trigger: 'blur' }],
                restValue: [{ required: true, message: '剩余值不能为空', trigger: 'blur' }],
                userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getMppGlobalvalueRecordList();
        this.getGlobalvalueTypeEnum();
        this.getGlobalvalueOrientationEnum();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetMppGlobalvalueRecordList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.mppGlobalvalueRecordList = [];
        },
        resetDialog() {
            this.mppGlobalvalueRecordState = 'add';
            this.showDialog = false;
            this.queryForm = {
                valueType: '', //数值类型
                value: '', //数值
                orientation: '', //方向
                originalValue: '', //原来值
                restValue: '', //剩余值
                userId: '' //用户ID
            };
            this.getMppGlobalvalueRecordList();
        },
        closeDialog() {
            this.showDialog = false;
            this.mppGlobalvalueRecord = {
                valueType: '', //数值类型
                value: '', //数值
                orientation: '', //方向
                originalValue: '', //原来值
                restValue: '', //剩余值
                userId: '' //用户ID
            };
        },
        submitForm() {
            if (this.mppGlobalvalueRecordState == 'add') {
                this.$refs.mppGlobalvalueRecordForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/globalvaluerecord/add`, { ...this.mppGlobalvalueRecord }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppGlobalvalueRecordList();
                                this.resetDialog();
                                this.getMppGlobalvalueRecordList();
                            }
                        });
                    }
                });
            } else if (this.mppGlobalvalueRecordState == 'edit') {
                this.$refs.mppGlobalvalueRecordForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/globalvaluerecord/edit`, { ...this.mppGlobalvalueRecord }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppGlobalvalueRecordList();
                                this.resetDialog();
                                this.getMppGlobalvalueRecordList();
                            }
                        });
                    }
                });
            }
        },
        addMppGlobalvalueRecord() {
            this.showDialog = true;
            this.mppGlobalvalueRecordState = 'add';
        },
        checkMppGlobalvalueRecord(mppGlobalvalueRecordId) {
            console.log(mppGlobalvalueRecordId);
            this.currentMppGlobalvalueRecordId = mppGlobalvalueRecordId;

            this.getMppGlobalvalueRecordById();
            this.showDialog = true;
            this.mppGlobalvalueRecordState = 'check';
        },
        editMppGlobalvalueRecord(mppGlobalvalueRecordId) {
            console.log('mppGlobalvalueRecord', mppGlobalvalueRecordId);
            if (mppGlobalvalueRecordId) {
                this.currentMppGlobalvalueRecordId = mppGlobalvalueRecordId;
                this.getMppGlobalvalueRecordById();
            } else {
                this.mppGlobalvalueRecord = { ...this.mppGlobalvalueRecord, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.mppGlobalvalueRecordState = 'edit';
        },
        deleteMppGlobalvalueRecord(mppGlobalvalueRecordId) {
            let ids = '';
            if (mppGlobalvalueRecordId) {
                ids = mppGlobalvalueRecordId;
            } else {
                ids = this.multipleSelection.map((mppGlobalvalueRecord) => mppGlobalvalueRecord.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mpp/globalvaluerecord/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMppGlobalvalueRecordList();
                            this.getMppGlobalvalueRecordList();
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshMppGlobalvalueRecordList() {
            this.resetMppGlobalvalueRecordList();
            this.getMppGlobalvalueRecordList();
        },
        getMppGlobalvalueRecordList(query = {}) {
            this.loading = true;
            get(`/mpp/globalvaluerecord/findList`, {
                ...this.queryForm,
                valueType: this.valueType,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.mppGlobalvalueRecordList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getMppGlobalvalueRecordById() {
            get(`/mpp/globalvaluerecord/get`, { id: this.currentMppGlobalvalueRecordId }).then((res) => {
                if (res.success) {
                    this.mppGlobalvalueRecord = { ...this.mppGlobalvalueRecord, ...res.mppGlobalvalueRecord };
                }
            });
        },
        /**
         * 导出信息
         */
        exportMppGlobalvalueRecordList() {
            //this.btnLoading = true;
            exprotExcel(`/mpp/globalvaluerecord/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/mpp/globalvaluerecord/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/mpp/globalvaluerecord/importData`, formData);
            this.refreshMppGlobalvalueRecordList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMppGlobalvalueRecordList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMppGlobalvalueRecordList();
        },
        getValue(value) {
            this.queryForm.userId = value;
        },
        getValueForm(value) {
            this.mppGlobalvalueRecord.userId = value;
        },


        // 获取GlobalvalueTypeEnum
        getGlobalvalueTypeEnum(){
            get('/mpp/utils/getEnum',{
                enumType: 'globalvalue_type'
            }).then((res)=>{
                if(res.success && res.code === 200){
                    this.globalvalueTypeEnumList = res.enumList
                }
            })
        },

        // 获取GlobalvalueOrientation
        getGlobalvalueOrientationEnum(){
            get('/mpp/utils/getEnum',{
                enumType: 'globalvalue_orientation'
            }).then((res)=>{
                if(res.success && res.code === 200){
                    this.globalvalueOrientationEnumList = res.enumList
                }
            })
        },

        // 计算computeGlobalvalue
        computeGlobalvalueType(type){
            for (let i = 0; i < this.globalvalueTypeEnumList.length; i++) {
                if(this.globalvalueTypeEnumList[i].key === type){
                    return this.globalvalueTypeEnumList[i].value
                }
            }
        },

        // 计算computeGlobalvalue
        computeGlobalvalueOrientation(type){
            for (let i = 0; i < this.globalvalueOrientationEnumList.length; i++) {
                if(this.globalvalueOrientationEnumList[i].key === type){
                    return this.globalvalueOrientationEnumList[i].value
                }
            }
        },
    }

};
</script>

<style lang='scss' scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>